// X12 EDI document-type code lookups used throughout the dashboard.

export const EDI_DOC_TYPES: Record<
  string,
  {label: string; description: string}
> = {
  '810': {label: 'Invoice', description: 'Supplier invoice to buyer'},
  '850': {label: 'Purchase Order', description: 'Buyer PO to supplier'},
  '855': {label: 'PO Acknowledgement', description: 'Supplier acknowledges PO'},
  '856': {label: 'ASN', description: 'Advance Ship Notice'},
  '852': {label: 'Product Activity', description: 'Inventory / POS activity'},
  '843': {label: 'RFQ Response', description: 'Response to request for quote'},
  '840': {label: 'RFQ', description: 'Request for quote'},
  '860': {label: 'PO Change', description: 'Purchase order change'},
  '820': {label: 'Remittance', description: 'Payment remittance advice'},
  '997': {label: 'Functional Ack', description: 'Functional acknowledgement'},
};

export function getDocTypeLabel(code: string): string {
  return EDI_DOC_TYPES[code]?.label ?? code;
}

export function getDocTypeDescription(code: string): string {
  return EDI_DOC_TYPES[code]?.description ?? 'Unknown document type';
}
